import { defineRouting } from 'next-intl/routing'

export const routing = defineRouting({
  locales: ['en', 'it'] as const,
  defaultLocale: 'it' as const,
  domains: [
    {
      domain: process.env.NODE_ENV === 'development' ? 'en.imagemilano.test:3000' : 'istitutoimage.com',
      defaultLocale: 'en',
      locales: ['en'],
      http: false,
    },
    {
      domain: process.env.NODE_ENV === 'development' ? 'it.imagemilano.test:3000' : 'istitutoimage.it',
      defaultLocale: 'it',
      locales: ['it'],
      http: false,
    },
  ],
})
